import { combineReducers } from '@reduxjs/toolkit';
import { rolesReducer } from './reducers/roles-reducer';
import { applicationRolesReducer } from './reducers/application-roles-reducer';
import type { IAuthState } from './interfaces';

export default combineReducers<IAuthState>({
  rolesReducer,
  applicationRolesReducer,
});
